'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import siteQuickSearch from './site-quick-search';

var navigation = {

  mobileNavigationIsOpened: false,
  tabletBreakPoint: 992,

  init: function() {

    /* Util functions */
    const transitionDone = function () {
      const el = document.createElement('fakeelement');
      const transitions = {
        'transition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      };
      for (const t in transitions) {
        if (el.style[t] !== undefined) {
          return transitions[t];
        }
      }
    };

    $('.header-nav.desktop .level-0 > li').each(function(){
      let mainLink = $(this).find('[data-trigger-megamenu]'),
        subNav = $(this).find('.level-1'),
        mainLinkClone = mainLink.clone();

      if( subNav.length ) {
        // first level link must be cloned into megamenu for touch devices
        $(mainLinkClone)
          .toggleClass('main-link-clone')
          .removeAttr('data-trigger-megamenu');
        $(subNav).before(mainLinkClone);

        // disable first level touch events if there are childs involved
        // this must be done for touch screen devices.
        $(mainLink).on('touchstart',(e)=> {
          e.preventDefault();
        });
      }

      // move megamenu content from navi to container
      const item = $(this).find('.mm-content') || '';

      // Add aria-attributes
      if (subNav.length > 0) {
        const linkUuid = mainLink.data('trigger-megamenu');
        const popoverId = 'megamenu-popover-' + linkUuid;
        item.attr('data-id', popoverId);
        mainLink.attr('aria-expanded', 'false').attr('aria-controls', popoverId);
      }

      $('.megamenu-all-content').append(item);
    });

    this.desktop(transitionDone); //Show one megamenu at a time on triggerlink hover
    this.initMobileNavigation();

  },

  desktop: function (transitionDone) {

    // Variables
    let $triggerLink = $('.header-nav .level-0 > li > a');
    const $triggerParent = $triggerLink.parent('li');
    const $wrapper = $('.megamenu-container'); // This el changes height.
    const $menu = $('.megamenu-container .mm-content'); // items in container
    const $header = $('header.header');
    const isNegative = $('.megamenu-header').hasClass('is-negative');

    let hoverTimer;

    // Trigger meganav on hover
    $triggerLink.on('touchstart mouseover',(e)=>{
      const $item = $(e.target).closest('li');

      if( e.type === 'touchstart' ){
        if( $item.hasClass('selected') ) {
          setTimeout(() => closeMenu(), 100);
        }
      }

      clearTimeout(hoverTimer);
      if( $item.hasClass('selected') ){
        return false;
      }
      if( !$triggerParent.hasClass('selected') ){
        hoverTimer = setTimeout(() => openMenu($item), 100);
      }
      else if ($triggerParent.hasClass('selected')) {
        hoverTimer = setTimeout(() => swapContent($item), 100);
      }
      $wrapper.mouseover(() => clearTimeout(hoverTimer));
    });

    // Basic keyboard interaction, suboptimal keys but atleast megamenu can be opened with keyboard
    // Whole navigation is getting UI renewal anyways so no need to do anything fancy
    $triggerLink.on('keydown', (e) => {
      const $item = $(e.target).closest('li');

      if (e.key === ' ') {
        if($item.hasClass('selected')){
          closeMenu($item);
        }
        else if(!$triggerParent.hasClass('selected')){
          openMenu($item);
        }
        else if ($triggerParent.hasClass('selected')) {
          swapContent($item);
        }
        return false;
      }
    })

    const isHeaderItemFocused = (element = null) => {
      element = element || document.activeElement;
      if (!element) {
        return false;
      }
      return element.closest('.header, .megamenu-container') !== null;
    };

    // Close megmenu if focused item is not in header
    const closeOnFocusIn = () => {
      if (!isHeaderItemFocused()) {
        closeMenu();
      }
    };

    // Close megmenu if escape is pressed when focusing on header item
    const closeOnEscape = (e) => {
      if (e.key === 'Escape' && isHeaderItemFocused()) {
        closeMenu();
      }
    };

    document.addEventListener('focusin', closeOnFocusIn);
    document.querySelectorAll('.nav-list-item, .megamenu-container').forEach(el => {
      el.addEventListener('keydown', closeOnEscape);
    });

    $wrapper.add($triggerLink).mouseout((e) => {
      if (!$(e.toElement).closest($wrapper).length) {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => closeMenu(), 350);
      }
    });


    /**
    * Calculate a new height for the mega menu for css transitions.
    * @param  {String} markup tabs content html
    * @return {Number}
    */
    function calculateNewWrapperheight(markup) {
      const $clone = $wrapper.clone()
        .insertAfter($wrapper)
        .html(markup)
        .css('height', '')
        .removeClass('closed');
      const newHeight = $clone.outerHeight();
      $clone.remove();
      $menu.addClass('visible').css('height', newHeight);
      return newHeight;
    }

    /**
    * Open the mega menu.
    * @param {jQuery} $item menu item
    */
    function openMenu($item) {
      siteQuickSearch.close();

      const slug = $item.children('a').data('trigger-megamenu');
      const markup = $('.megamenu-all-content .mm-content[data-target="' + slug + '"]')[0].outerHTML;
      const newHeight = calculateNewWrapperheight(markup);
      $item.addClass('selected');
      $wrapper.css('height', 0);
      $wrapper.css('height');
      $header.toggleClass('hover',true);

      $wrapper.html(markup)
        .removeAttr('inert')
        .css('height', newHeight)
        .removeClass('closed');
      $menu.addClass('visible').css('height', newHeight);
      //remove negative header style
      if(isNegative === true) {
        $('.megamenu-header').removeClass('is-negative');
      }

      // Add id to active megamenu and toggle aria-expanded attribute
      const content = $wrapper.find('.mm-content');
      content.attr('id', content.data('id'));
      $item.find('[data-trigger-megamenu]').attr('aria-expanded', 'true');
    }

    /**
    * Close the mega menu.
    * @param {jQuery} $item menu item
    */
    function closeMenu($item) {
      if (!$item || $item && !$item.length) {
        $item = $triggerParent;
      }
      $item.removeClass('selected');
      $item.find('[data-trigger-megamenu]').attr('aria-expanded', 'false');
      $wrapper.css('height', $wrapper.outerHeight());
      $wrapper.css('height');
      $wrapper.attr('inert', '');
      $wrapper.addClass('closed');
      if (!siteQuickSearch.isOpen()) {
        $header.toggleClass('hover',false);
      }
      $menu.removeClass('visible').css('height', 0);
      //add negative header style if it was set in the beginning
      if(isNegative === true) {
        $('.megamenu-header').addClass('is-negative');
      }
    }

    /**
    * Swaps the mega menu contents.
    * @param  {jQuery} $item  menu item
    * @return {Promise}
    */
    function swapContent($item) {
      $wrapper.css('height', '');
      // const slug = $item.find('a').data('trigger-megamenu');
      // const markup = $('.js-megamenu[data-target="' + slug + '"]').html();
      const slug = $item.children('a').data('trigger-megamenu');
      const markup = $('.megamenu-all-content .mm-content[data-target="' + slug + '"]')[0].outerHTML;
      const newHeight = calculateNewWrapperheight(markup);

      const fade = () => {
        const oldContent = $wrapper.find('.mm-content');
        $(`[data-trigger-megamenu="${oldContent.data('target')}"]`).attr('aria-expanded', 'false');
        return oldContent.fadeOut(150).promise().then(() => {
          $wrapper.html(markup);
          const content = $wrapper.find('.mm-content');
          content.attr('id', content.data('id'));

          return content.hide().fadeIn(150).promise().then(() => {
            $item.find('[data-trigger-megamenu]').attr('aria-expanded', 'true');
          });
        });
      };
      const setHeight = () => {
        const promise = new $.Deferred();
        $wrapper.css('height', newHeight).one(transitionDone(), promise.resolve);
        return promise;
      };
      $triggerParent.removeClass('selected');
      $item.addClass('selected');

      $wrapper.css('height', $wrapper.outerHeight());
      $wrapper.css('height');

      return newHeight <= $wrapper.outerHeight() ? fade().then(() => { setHeight(); }) : $.when(setHeight(), fade());
    }

  },

  /**************************/
  /**   MobileNavigation   **/
  /**************************/
  toggleMobileNavigation: function() {
    $('body').toggleClass('mobile-navigation-opened');
    this.mobileNavigationIsOpened = $('body').hasClass('mobile-navigation-opened');
    window.scrollTo(0, 0);
    if (!this.mobileNavigationIsOpened) {
      $('.mobile-navigation').attr('inert', '');
    }
    else {
      $('.mobile-navigation').removeAttr('inert');
    }
  },

  toggleMobileNavigationTree($li, expand){
    var $childUl = $li.children('ul').first();
    var scrollHeight = $childUl.prop('scrollHeight');
    var clientHeight = $childUl.prop('clientHeight');
    var expandTimer = $childUl.prop('expandTimer');
    if(expandTimer){
      clearTimeout(expandTimer);
    }

    // Do expand by the expand parameter or automatically based on clientHeight of $childUl
    var doExpand = (typeof expand === 'boolean' ? expand : clientHeight <= 0);

    if(doExpand){
      // Open the child ul
      $li.addClass('expanded');
      $childUl.css('height', scrollHeight+'px');
      expandTimer = setTimeout(function(){
        $childUl.css('height', 'auto');
      }, 200);
      $childUl.prop('expandTimer', expandTimer);
    } else {
      // Close the child ul
      $li.removeClass('expanded');
      $childUl.css('height', scrollHeight+'px');
      setTimeout(function(){
        $childUl.css('height', '0px');
      }, 1);
    }
  },

  crawlMainNavigationLinksTree: function(){
    var navigationTree = [];
    var $primaryNavItems = $('.primary-nav .nav-list-item');
    $primaryNavItems.each(function(){
      var $topLink = $(this).children('a[data-trigger-megamenu]').not('.hidden').first(); // Filter out .hidden links (e.g. season depending tyre links)

      if($topLink.length){
        var megamenuTarget = $topLink.attr('data-trigger-megamenu');
        var $childLinksContainers = $('.megamenu-all-content .mm-content[data-target="'+megamenuTarget+'"] .links > ul').first().children('li');

        var childLinks = [];
        $childLinksContainers.each(function(){
          var $childLink = $(this).children('a').not('.hidden').first(); // Filter out .hidden links (e.g. season depending tyre links)

          if($childLink.length){
            var $subChildLinks = $(this).children('ul').first().find('a'); // Just get all the links

            var subChildLinks = [];
            $subChildLinks.each(function(){
              const $subChildLink = $(this);

              subChildLinks.push({
                href: $subChildLink.attr('href'),
                text: $subChildLink.text(),
                target: $subChildLink.attr('target'),
                selected: $subChildLink.hasClass('selected'),
                current: $subChildLink.hasClass('current'),
                class: $subChildLink.hasClass('pl1') ? 'pl1' : '', // Include indent
              });
            });

            childLinks.push({
              href: $childLink.attr('href'),
              text: $childLink.text(),
              target: $childLink.attr('target'),
              selected: $childLink.hasClass('selected'),
              current: $childLink.hasClass('current'),
              children: subChildLinks,
            });
          }
        });

        var topLink = {
          href: $topLink.attr('href'),
          text: $topLink.text(),
          target: $topLink.attr('target'),
          selected: $topLink.hasClass('selected'),
          current: $topLink.hasClass('current'),
          children: childLinks,
        };

        navigationTree.push(topLink);
      }
    });

    return navigationTree;
  },

  clickExpander($expander){
    var self = this;
    var $li = $expander.closest('li');
    var $parentUl = $li.closest('ul');

    // Close opened trees in this level
    var $openedLisExceptThis = $parentUl.find('li.expanded').not($li);
    $openedLisExceptThis.each(function(){
      self.toggleMobileNavigationTree($(this), false);
    });

    this.toggleMobileNavigationTree($li);
  },

  initMobileNavigation: function(){
    var self = this;
    var mobileNavigationTreeTemplate = $('#mobile-navigation-tree-template').html();

    if(mobileNavigationTreeTemplate){
      // Get links from current mega nav as tree and render them into "pages" section in mobile navigation
      var mainNavigationLinksTree = self.crawlMainNavigationLinksTree();
      $('#mobile-navigation-pages').html(Mustache.render(mobileNavigationTreeTemplate, mainNavigationLinksTree));
      $('.mobile-navigation').attr('inert', '');
      $('[data-js-mobile-navigation-toggle]').on('click', function(evt){
        evt.preventDefault();
        self.toggleMobileNavigation();
      });

      $('.mobile-navigation').on('click', '[data-js-mobile-navigation-tree-expand]', function(evt){
        evt.preventDefault();
        self.clickExpander($(this));
      });
    }
  }

}; // navigation

export default navigation;
